"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadMethodsFromMFE = void 0;
const react_1 = require("react");
const uuid_1 = require("uuid");
const useLoadMFE_1 = require("./useLoadMFE");
const isMethodInMFE = (methodName, mfe) => {
    return typeof mfe === "object" && methodName in mfe;
};
const getMethod = (methodName, mfe) => {
    if (isMethodInMFE(methodName, mfe)) {
        return mfe[methodName];
    }
    return null;
};
/**
 * @typeParam T - This should reflect the type of the methods you want to import.
 * Example: { methodOne: (id: string) => void, methodTwo: (id: string) => void }
 */
const useLoadMethodsFromMFE = ({ importPath, methodNames, }) => {
    const [data, setData] = (0, react_1.useState)({ isPending: true });
    const [refreshKey, setRefreshKey] = (0, react_1.useState)("");
    const loadMFE = (0, useLoadMFE_1.useLoadMFE)({ importPath });
    const refreshImport = () => {
        setRefreshKey((0, uuid_1.v4)());
    };
    (0, react_1.useEffect)(() => {
        (async () => {
            const loadedMfe = await loadMFE();
            setData({
                ...loadedMfe,
                isPending: false,
            });
        })();
    }, [loadMFE, refreshKey]);
    if (data.isPending) {
        return {
            methods: undefined,
            isPending: data.isPending,
            error: undefined,
            reset: refreshImport,
        };
    }
    if (data.error) {
        return {
            methods: null,
            isPending: data.isPending,
            error: data.error,
            reset: refreshImport,
        };
    }
    const methods = methodNames.reduce((previous, current) => {
        const returnedMethod = { ...previous };
        returnedMethod[current] = getMethod(current, data.mfe);
        return returnedMethod;
    }, {});
    return {
        methods: methods,
        isPending: data.isPending,
        error: undefined,
        reset: refreshImport,
    };
};
exports.useLoadMethodsFromMFE = useLoadMethodsFromMFE;
//# sourceMappingURL=useLoadMethodsFromMFE.js.map